<ng-container>
	<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
		<div fxLayout="row wrap" fxLayoutAlign="space-around" fxLayoutGap="0px grid" fxLayoutGap.lt-xl="12px grid">
			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-6Ac" translate>身長</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="height" matInput max="999" min="0" name="height" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="old-user-t-7Ln">cm</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-9In" translate>ゴルフ暦</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="experience" matInput max="999" min="0" name="experience" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="old-user-t-5Zu" translate>年</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-2Hb" translate>平均スコア</span></mat-label>
				<input [(ngModel)]="score" matInput max="999" min="0" name="score" placeholder="" step="1" style="text-align: right;" type="number">
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-2Dm" translate>ドライバーの距離</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="driver" matInput max="999" min="0" name="driver" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="old-user-t-2Gu" translate>Yard</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-1Zr" translate>7番アイアンの距離</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="seveniron" matInput max="999" min="0" name="seveniron" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="old-user-t-0Tz" translate>Yard</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-3Gk" translate>年間ラウンド回数</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="rounds" fxFlex="70" matInput max="999" min="0" name="rounds" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="old-user-t-9Ht" fxFlex translate>回/年</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-6Wt" translate>月間練習回数</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="practice" fxFlex="70" matInput max="999" min="0" name="practice" placeholder="" step="1" style="text-align: right;" type="number">
					<div data-idtest="old-user-t-3Vu" fxFlex translate>回/月</div>
				</div>
			</mat-form-field>

			<mat-form-field appearance="outline" class="input-text" fxFlex.lt-sm="50" fxFlex.lt-xl="25" fxFlex.lt-md="33">
				<mat-label><span data-idtest="old-user-t-1Qn" translate>オフィシャルハンディ</span></mat-label>
				<div fxLayout="row">
					<input [(ngModel)]="handicap" matInput max="99" min="0" name="handicap" placeholder="" step="1" style="text-align: right;" type="number">
				</div>
			</mat-form-field>

		</div>

		<div fxLayout="row" fxFlex="100" fxLayoutAlign.lt-sm="center center" fxLayoutAlign="column" style="margin-top: 16px; color: #ffffff;background: #1d1d1d;">
			<div data-idtest="old-user-t-3Bh" class="card-title" style="padding:12px 0 12px 16px;font-size: 14px;letter-spacing: 0.2em;" translate>所属先トレーナー設定</div>
		</div>
		<div fxLayout="row wrap" fxFill fxLayoutAlign="space-evenly" class="card-background">
			<div fxLayout="column" fxLayoutAlign="center" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" style="margin:20px;background: #585858;box-shadow: 1px 4px 2px #20202040;">
				<div fxLayout="row wrap" fxLayoutAlign="center" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" style="background: #585858;">
					<mat-card style="margin:8px;" fxLayoutGap="8px">
						<mat-card-header>
							<mat-card-title style="font-size: 1.6vh;font-weight: bold;margin-bottom: 0;"><span data-idtest="old-user-t-2Xm" translate>スタジオ選択</span></mat-card-title>
							<span data-idtest="old-user-t-0Qe" style="font-size: 8px;border: 1px solid #ccc;" translate>必須入力</span>
						</mat-card-header>
						<mat-card-content>
							<div fxlayout="row">
								<mat-form-field class="input-text" style="width: 100%;">
									<mat-label><span data-idtest="old-user-t-1Nf" translate>スタジオ</span></mat-label>
									<mat-select #studio_select="ngModel" (selectionChange)="onChangeStudio()" [(ngModel)]="studio" name="studio_select" required>
										<mat-option *ngFor="let studio of studios" [value]="studio">
											{{studio.account.content.nickname}}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="studio_select.errors?.['required'];"><span translate>選択してください</span></mat-error>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;" fxLayoutGap="8px">
						<mat-card-header>
							<mat-card-title style="font-size: 1.6vh;font-weight: bold;margin-bottom: 0px;"><span data-idtest="old-user-t-4Yr" translate>トレーナー選択</span></mat-card-title>
							<span data-idtest="old-user-t-1As" style="font-size: 8px;border: 1px solid #ccc;" translate>必須入力</span>
						</mat-card-header>
						<mat-card-content>
							<div fxlayout="row">
								<mat-form-field class="input-text" style="width: 100%;">
									<mat-label><span data-idtest="old-user-t-1Vd" translate>トレーナー</span></mat-label>
									<mat-select #belongto_select="ngModel" (selectionChange)="onChangeTrainer()" [(ngModel)]="trainer" name="trainer_select" required>
										<mat-option *ngFor="let trainer of trainers" [value]="trainer">
											{{trainer.account.content.nickname}}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="belongto_select.errors?.['required'];"><span translate>選択してください</span></mat-error>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
				</div>
				<div style="margin:8px;text-align: center;" fxLayoutGap="8px">
					<button mat-raised-button (click)="onAddItem(trainer.account)" [disabled]="(form.invalid || isProgress || !trainer.account)" style="background-color:#8e8e8e;width: 110px;">
						<div fxLayout="row" fxLayoutAlign="space-between center">
							<mat-icon fxFlex="30">add_circle</mat-icon>
							<div data-idtest="old-user-t-3Cr" fxFlex="70" translate>追加</div>
						</div>
					</button>
				</div>
			</div>
			<belongs-panel #belongs_panel style="margin:20px;box-shadow: 1px 4px 2px rgba(47,15,15,0.25);" [auth]="auth" [account]="account"></belongs-panel>
		</div>
		<div class="borders" style="background: rgb(25, 25, 25);">
			<div class="slanting">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none" style="height: 30px;width: 100%;background: rgb(25, 25, 25);">
					<defs>
						<linearGradient id="g1" x1="0%" y1="0%" x2="0%" y2="100%">
							<stop offset="0" stop-color="#383838"/>
							<stop offset="1" stop-color="#282828"/>
						</linearGradient>
					</defs>
					<polygon points="0,0 50,100 100,0" fill="url(#g1)"></polygon>
				</svg>
			</div>
		</div>
		<div fxLayout="row" fxFlex="100" fxLayoutAlign="column" style="color: #ffffff;background: #191919;">
			<div class="left-half"></div>
			<div class="right-half"></div>
			<div data-idtest="old-user-t-9Uk" class="card-title" style="padding:12px 0px 12px 16px;font-size: 14px;letter-spacing: 0.2em;" translate>所属先トレーナー</div>
		</div>
		<div fxlayout="column" style="background: #191919;">
			<mat-card class="overwrap-card" style="background: #191919;">
				<mat-card-content>
					<mat-form-field fxFlex>
						<mat-chip-list #columnList aria-label="column">
							<mat-chip (removed)="onRemoveItem(trainer.account)" *ngFor="let trainer of selected_trainers" [removable]="true" [selectable]="true">
								{{trainer.account.content.nickname}}
								<mat-icon matChipRemove>cancel</mat-icon>
							</mat-chip>
						</mat-chip-list>
					</mat-form-field>
				</mat-card-content>
			</mat-card>
		</div>
		<div fxLayout="row" fxLayoutAlign="center">
			<button (click)="onAccept()" [disabled]="form.invalid || isProgress" style="margin:20px;background-color:#99774a;width: 200px;" mat-raised-button id="mat-update-button">
				<div fxLayout="row" fxLayoutAlign="space-between center">
					<mat-icon fxFlex="10">done_outline</mat-icon>
					<div data-idtest="old-user-t-1Rf" fxFlex="80" translate>更新</div>
					<div fxFlex="10"></div>
				</div>
			</button>
		</div>
	</form>
</ng-container>
